import { changeTheme, getNaiveThemeOverrides, getNaiveThemeCustomStyle } from '@/themes'
import { useCssVar, useStyleTag } from '@vueuse/core'
import { kebabCase } from 'lodash-es'
import { defineStore } from 'pinia'
import api from '@/api'

export const defaultLayout = 'simple'

export const useAppStore = defineStore('app', {
  state: () => ({
    collapsed: false,
    layout: defaultLayout,
    theme: 'theme-1',
    naiveThemeOverrides: {},
    themeCustomStyle: useStyleTag(''),
    fileViewHost: ''
  }),
  actions: {
    switchCollapsed() {
      this.collapsed = !this.collapsed
    },
    setCollapsed(b: boolean) {
      this.collapsed = b
    },
    setLayout(v: string) {
      this.layout = v
    },
    async setTheme(theme: string) {
      this.theme = theme
      const cssVars = changeTheme(theme)
      for (const key in cssVars) {
        useCssVar(`--${kebabCase(key)}`, document.documentElement).value =
          cssVars[key as keyof typeof cssVars] || ''
      }
      const customStyle = await getNaiveThemeCustomStyle(theme)
      this.themeCustomStyle.css = customStyle
      this.naiveThemeOverrides = await getNaiveThemeOverrides(theme)
    }
  },
  persist: [
    {
      paths: ['collapsed'],
      storage: sessionStorage
    },
    {
      paths: ['fileViewHost'],
      storage: localStorage
    }
  ]
})
